module.exports = __webpack_public_path__ + "img/return.59a993f1.svg";